import type { CertificatePriceLimit } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'

export const useCertificatePriceLimit = (): string => {
  const { certificatePriceLimit } = useStaticData<{
    certificatePriceLimit: CertificatePriceLimit | null
  }>()

  return certificatePriceLimit?.displayPrice ?? ''
}
